// Lee el contador de pacientes en espera que mantiene `AvisosSala` (el único que consulta al servidor): el menú de cualquier pantalla solo lo muestra.
import { useSyncExternalStore } from 'react';
import { leerContadorSala, suscribirContadorSala, type EstadoContadorSala } from './salaHce';

export function useContadorSala(): EstadoContadorSala {
  return useSyncExternalStore(suscribirContadorSala, leerContadorSala, leerContadorSala);
}
